import { render, staticRenderFns } from "./AccountWaivers.vue?vue&type=template&id=5b6d4c6f"
import script from "./AccountWaivers.vue?vue&type=script&lang=js"
export * from "./AccountWaivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports